import createContext from '~/src/libs/createContext';
import { PACK_QUANTITY_CHANGE, PACK_SIZE_CHANGE, UPDATE_PRODUCT, setPackSize, changeQuantity, updateProduct } from './pd.actions';

const pdInitialState = {
  base_img_url: '',
  packSize: [],
  packSelected: {},
  isCosmetic: false,
};

const pdReducer = (state = pdInitialState, action) => {
  const selectedPack = state?.packSize?.find((pack) => pack?.id === action?.id);
  switch (action.type) {
    case UPDATE_PRODUCT:
      return { ...state, ...action?.payload };
    case PACK_SIZE_CHANGE:
      return {
        ...state,
        packSelected: selectedPack,
      };
    case PACK_QUANTITY_CHANGE:
      return {
        ...state,
        packSize: state?.packSize?.map((pack) => {
          if (pack.id == action.id) {
            return {
              ...pack,
              cart_count: action.quantity,
            };
          } else {
            return pack;
          }
        }),
        packSelected: {
          ...state.packSelected,
          cart_count: action.quantity,
        },
      };
    default:
      return state;
  }
};

export const { Context: PDContext, Provider: PDProvider } = createContext(pdReducer, { changeQuantity, setPackSize, updateProduct }, pdInitialState);
